"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("../../../../styles/baseTable.scss");
var ui_1 = require("@vidazoo/ui");
var UserRow = /** @class */ (function (_super) {
    tslib_1.__extends(UserRow, _super);
    function UserRow(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onEdit = function () {
            var _a = _this.props, user = _a.user, onEdit = _a.onEdit;
            onEdit(user);
        };
        _this.onDelete = function () {
            var _a = _this.props, user = _a.user, onDelete = _a.onDelete;
            onDelete(user);
        };
        _this.onUnblock = function () {
            var _a = _this.props, user = _a.user, onUnblock = _a.onUnblock;
            onUnblock(user);
        };
        return _this;
    }
    UserRow.prototype.getUserRoles = function () {
        var user = this.props.user;
        if (user.scopes.length && user.scopes[0].roles.length) {
            return user.scopes[0].roles.map(function (role) { return role.name; }).join(", ");
        }
        return null;
    };
    UserRow.prototype.render = function () {
        var user = this.props.user;
        return (React.createElement("tr", null,
            React.createElement(ui_1.TableCell, null,
                React.createElement("div", { className: theme.name },
                    user.block ? React.createElement(ui_1.Tooltip, { position: "right", title: "User Block: " + user.blockReason },
                        React.createElement("div", { className: theme.errorIcon },
                            React.createElement(ui_1.Icon, { iconName: "icon-cancel-small", size: 2, iconColor: "red" }))) : null,
                    user.firstName,
                    " ",
                    user.lastName)),
            React.createElement(ui_1.TableCell, null, user.email),
            React.createElement(ui_1.TableCell, null, user.organization.name),
            React.createElement(ui_1.TableCell, null, this.getUserRoles()),
            React.createElement(ui_1.TableCell, null,
                React.createElement("div", { className: theme.links },
                    React.createElement(ui_1.LinkButton, { type: "button", onClick: this.onEdit, iconName: "icon-edit", iconSize: 1.8 }),
                    React.createElement(ui_1.LinkButton, { type: "button", onClick: this.onDelete, iconName: "icon-delete", iconSize: 1.8 }),
                    user.block ? React.createElement(ui_1.Tooltip, { position: "left", title: "Unblock user" },
                        React.createElement(ui_1.LinkButton, { type: "button", onClick: this.onUnblock, iconName: "icon-approved-status", iconSize: 1.8 })) : null))));
    };
    UserRow.defaultProps = {};
    return UserRow;
}(React.Component));
exports.default = UserRow;
